import IconGitHubSolid from '@apollo/icons/default/IconGitHubSolid.svg';
import { Button } from '@apollo/orbit';
import React from 'react';

import type { OnboardingUserSegmentType } from 'src/app/onboarding/routes/routes';
import { useHandleProviderSubmit } from 'src/hooks/useHandleProviderSubmit';
import { events } from 'src/lib/tracking';

interface Props {
  className?: string;
  disabled?: boolean;
  loggingIn: boolean;
  setLoggingIn: React.Dispatch<React.SetStateAction<boolean>>;
  callbackUrl: string;
  type: OnboardingUserSegmentType;
}

export const GithubSignupCTA = ({
  className,
  disabled,
  loggingIn,
  setLoggingIn,
  callbackUrl,
  type,
}: Props) => {
  const handleProviderSubmitGithub = useHandleProviderSubmit({
    provider: 'github',
    // GitHub sign-ins should always redirect to the welcome page, so we don't
    // lose the referrer `type` in the query param.
    callbackUrl,
    setLoggingIn,
    type,
  });

  return (
    <Button
      className={className}
      type="button"
      size="lg"
      isDisabled={disabled}
      isLoading={loggingIn}
      onClick={() => {
        /* eslint-disable @typescript-eslint/naming-convention */
        events.registration_auth_method_selected.track({
          registration_variant: 'studio-direct',
          authorization_method: 'github',
        });
        /* eslint-enable @typescript-eslint/naming-convention */
        handleProviderSubmitGithub();
      }}
      loadingText="Signing up"
      leftIcon={<IconGitHubSolid />}
      variant="primary"
    >
      Sign up with GitHub
    </Button>
  );
};
